import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';
import { format } from '../../../shared/lib/format';

const tags = {
  getConversions: 'getConversions',
  getConversion: 'getConversion',
  downloadConversionsExcel: 'downloadConversionsExcel',
};

const initialState = {
  limit: 25,
  start: '',
  end: '',
  asset_type: '',
  conversion_id: '',
  cursors: [null],
  currentPageIndex: 0,
};

export const conversionsApi = createApi({
  reducerPath: 'conversionsApi',
  tagTypes: [tags.getConversions, tags.getConversion, tags.downloadConversionsExcel],
  endpoints: (builder) => ({
    getConversion: builder.mutation({
      query: ({ pk, sk }) => {
        return ({
          method: 'post', url: `/transaction-info/conversion`,
          body: { pk: pk, sk: sk },
        });
      },
      providesTags: [tags.getConversion],
    }),
    getConversions: builder.query({
      query: ({ limit, start, end, asset_type, conversion_id, cursor }) => ({
        method: 'post',
        url: `/transaction-info/conversion/list/v2?${serialize({
          page_size: limit,
          ...start ? { start: `${start.getDate()}/${format.addZeroBefore(start.getMonth() + 1)}/${start.getFullYear()}` } : {},
          ...end ? { end: `${end.getDate()}/${format.addZeroBefore(end.getMonth() + 1)}/${end.getFullYear()}` } : {},
          ...asset_type ? { asset_type } : {},
          ...conversion_id ? { convert_id: conversion_id } : {},
        })}`,
        body: cursor || undefined,
      }),
      providesTags: [tags.getConversions],
      transformResponse: (data, meta) => {
        if (meta?.response?.status === 422 && data?.message === '') {
          return {
            list: [],
            nextCursor: null,
          };
        }
        return {
          list: data.conversion_list || [],
          nextCursor: data.next_cursor || null,
        };
      },
    }),
  }),
});

export const conversionsParams = createSlice({
  name: 'conversionsParams',
  initialState,
  reducers: {
    setParams(state, action) {
      return { ...state, ...action.payload, cursors: [null], currentPageIndex: 0 };
    },
    goToNextPage(state, action) {
      const nextCursor = action.payload;
      if (state.currentPageIndex + 1 >= state.cursors.length) {
        state.cursors.push(nextCursor);
      }
      state.currentPageIndex += 1;
    },
    goToPrevPage(state) {
      if (state.currentPageIndex > 0) state.currentPageIndex -= 1;
    },
  },
});

export const { setParams, goToNextPage, goToPrevPage } = conversionsParams.actions;
export const { useGetConversionsQuery, useGetConversionMutation } = conversionsApi;
export const conversionsParamsReducer = conversionsParams.reducer;
export const conversionsParamsSelector = (state) => state.conversionsParams;